import React from 'react';

const Vue_VFor = () => {
  return (
    <div>
      <h1>Vue_VFor Component</h1>
      <p>This is the Vue_VFor tutorial page.</p>
    </div>
  );
}

export default Vue_VFor;
